import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

const DashboardDefault = Loadable(lazy(() => import('pages_v/dashboard/default')));
const Clientes = Loadable(lazy(() => import('pages_v/clientes')));
const ClienteDetalle = Loadable(lazy(() => import('pages_v/clientes/detalle')));
const Ventas = Loadable(lazy(() => import('pages_v/ventas')));
const VentaDetalle = Loadable(lazy(() => import('pages_v/ventas/detalle')));

// ==============================|| VRP ROUTING ||============================== //

const VrpRoutes = {
  path: '/v',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    { path: '', element: <Navigate to="/v/dashboard/default" replace /> },
    {
      path: 'dashboard',
      children: [
        { path: 'default', element: <DashboardDefault /> },
        { path: 'clientes', element: <Clientes /> },
        { path: 'clientes/:id', element: <ClienteDetalle /> },
        { path: 'ventas', element: <Ventas /> },
        { path: 'ventas/detalle/:id', element: <VentaDetalle /> }
      ]
    }
  ]
};

export default VrpRoutes;
